
import DetailsMenuItems from './DetailsMenuItems';

const RSOnepageMobileMenu = (props) => {
    const { item1, item2, item3, item7, menuOpen } = props;
    return (
        <div className="container relative">
            <div className={menuOpen ? "mobile-menu-part open" : "mobile-menu-part"}>
                <div className="mobile-menu">
                    <ul className="nav-menu">
                    <DetailsMenuItems
                            menuItem1={item1 ? item1 : 'Home'}
                            menuItem2={item2 ? item2 : 'About'}
                            menuItem3={item3 ? item3 : 'Services'}
                            menuItem7={item7 ? item7 : 'Contact'}
                        />
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default RSOnepageMobileMenu;